var map = {
	"./layouts/bbb/default.js": 1229,
	"./layouts/iframe/default.js": 968,
	"./layouts/jsqueue/empty.js": 969,
	"./layouts/jsqueue/page-white-header.js": 970,
	"./layouts/jsqueue/page.js": 982
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 941;